import React, { useState } from 'react';
import {
	Grid,
	makeStyles,
	Button,
	Box,
	Container,
	Paper,
	Tooltip,
} from '@material-ui/core';
import AddSignature from '../../../assets/img/campofirma.png';
import agrandar from '../../../assets/img/AgrandarDoc.jpg';
import alejar from '../../../assets/img/AlejarDoc.jpg';
import { useDispatch, useSelector } from 'react-redux';
import siguiente from '../../../assets/img/sig.png';
import atras from '../../../assets/img/ant.png';
import IconManuscrita from '../../../assets/img/ico-manuscrita.png';
import AddIcon from '@material-ui/icons/Add';
import ModalReject from './modales/ModalReject';
import ModalConfirmReject from './modales/ModalConfirmReject';
import MessagePantallaCarga from './modales/MessagePantallaCarga';
// import ModalHaveCertificate from './modales/ModalHaveCertificate';
import ModalUps from './modales/ModalUps';
import ModalFinishedSigning from './modales/ModalFinishedSigning';
import ModalSignatureRejected from './modales/ModalSignatureRejected';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
	modalFinished,
	modalMissingSignatures,
	modalReject,
	modalSign,
} from '../../../redux/actions/CircuitoFirmasAction';
import ModalMissingSignatures from './modales/ModalMissingSignatures';
import ModalSign from './modales/ModalSign';
import CanvasDragResize from '../FirmaAvanzada/CanvasDragResize';
import { kbToMb } from '../../../helpers/FilesFunction';
import {
	MAX_MEGAS_FILE_SIZE,
	MAX_MEGAS_FILES_SIZE,
	API_HOSTNAME_AWS,
	APP_KEY,
	IMAGEN_FIRMA_PREDEF,
} from '../../../redux/types/ApiConstants';
import { useSnackbar } from 'notistack';
import { PDFDocument } from 'pdf-lib';
import { getListSignature } from '../../../helpers/SignatureUtil';
import { useEffect } from 'react';
import Loading from '../../../components/Loading';
import {
	getFilesCF,
	getManuscritaByUser,
} from '../../../redux/actions/SignAction';
import ModalFirmaCliente from './modales/ModalFirmaCliente';
import {
	SignCustomWithoutdocument,
	SignCustomWithoutdocumentS3,
	firmaAvanzadaTokenCF,
} from '../../../redux/actions/SignCunstomDocumentAction';
import { useHistory } from 'react-router-dom';
import { encriptar } from '../../../redux/actions/Encriptar';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { truncarNombreCompleto } from '../../../helpers/helpNames';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const useStyle = makeStyles({
	boxes: {
		height: '600px',
	},
	flex: {
		display: 'flex',
		justifyContent: 'space-between',
		'@media (max-width: 600px)': {
			flexDirection: 'column', // Apila en columna en pantallas pequeñas
			alignItems: 'flex-start', // Alinea los títulos a la izquierda en pantallas pequeñas
		},
	},
	iconsPdf: {
		display: 'flex',
		justifyContent: 'flex-start',
		padding: '0',
		cursor: 'pointer',
	},
	iconSpacing: {
		margin: '0 8px', // Ajusta el margen horizontal según sea necesario
		'@media (max-width: 600px)': {
			fontSize: '1.1rem',
		},
	},
	iconPdf: {
		margin: '0 2px 8px 2px',
		width: '32px',
		height: '20px',
		borderLeft: '2px solid #DFDFDF',
		padding: '0 6px 0 ',
		'@media (max-width: 600px)': {
			fontSize: '1.1rem',
		},
	},
	icon1Pdf: {
		margin: '0 2px 8px 2px',
		width: '32px',
		height: '20px',
		padding: '0 6px 0 ',
		'@media (max-width: 600px)': {
			fontSize: '1.1rem',
		},
	},
	modal: {
		width: '100%',
		height: '100vh',
		backgroundColor: '#00000099',
		position: 'fixed',
		top: 0,
		left: 0,
	},
	size: {
		fontSize: '18px',
		colo: '4F4F4F',
		margin: '8px 0 36px 0',
	},
	parrafo: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		fontSize: '14px',
		color: '#4F4F4F',
		fontFamily: 'mulish',
		// maxWidth: "183px",
		minWidth: '130px',
		margin: '0',
		marginBottom: '16px',
		'@media(max-width:599px)': {
			display: 'none',
		},
	},
	parrafo2: {
		display: 'none',
		justifyContent: 'left',
		alignItems: 'center',
		fontSize: '14px',
		color: '#202427',
		fontFamily: 'mulish',
		// maxWidth: "183px",
		minWidth: '130px',
		margin: '0',
		marginBottom: '16px',
		'@media(max-width:599px)': {
			display: 'flex',
			justifyContent: 'left',
			maxWidth: '599px',
			gap: '10px',
			flexDirection: 'column',
			alignItems: 'baseline',
			marginTop: '20px',
			fontSize: '1rem',
			fontWeight: '700',
		},
	},
	hr: {
		color: '#7B7B7B',
		margin: '0',
		// maxWidth: "183px",
		minWidth: '130px',
		'@media(max-width:599px)': {
			display: 'none',
		},
	},
	div: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '8px',
		padding: '2px 8px',
		border: '1px solid #E3E3E3',
		borderRadius: '5px',

		'@media(max-width:599px)': {
			justifyContent: 'space-around',
			width: '100%',
			gap: '10px',
			marginLeft: '0',
			padding: '12px 8px',
			fontSize: '1.3rem',
			fontWeight: '500',
		},
	},
	listado: {
		fontFamily: 'mulish',
		fontSize: '16px',
		color: '#444444',
		marginTop: '16px',
	},
	listado2: {
		fontFamily: 'mulish',
		fontSize: '16px',
		color: '#444444',
		marginTop: '4%',
		'@media(max-width:599px)': {
			fontSize: '1rem',
		},
	},
	btns: {
		display: 'flex',
		gap: '16px',
		alignItems: 'center',
		'@media(max-width:600px)': {
			display: 'none',
		},
	},
	btns2: {
		display: 'none',
		gap: '16px',
		alignItems: 'center',
		'@media(max-width:600px)': {
			gap: '20px',
			flexDirection: 'column-reverse',
			width: '100%',
			display: 'flex',
		},
	},
	btnRechazar: {
		color: '#E55200',
		padding: '8px 24px',
		fontSize: '16px',
		cursor: 'pointer',
		border: '1px solid #E55200',
		borderRadius: '8px',
		backgroundColor: 'transparent',
		fontFamily: 'Mulish',
		fontWeight: '700',
		margin: 0,
		'@media(max-width:600px)': {
			width: '100%',
			padding: '8px 24px',
			fontSize: '1.1rem',
		},
	},
	continue: {
		backgroundColor: '#E55200',
		color: 'white',
		padding: '8px 24px',
		fontSize: '16px',
		cursor: 'pointer',
		fontWeight: '800',
		fontFamily: 'Mulish',
		border: '1px solid #E55200',
		borderRadius: '8px',
		'&:hover': {
			backgroundColor: '#E55200',
		},
		'@media(max-width:600px)': {
			width: '100%',
			padding: '8px 24px',
			fontSize: '1.1rem',
			'& img': {
				width: '24px',
				height: '24px',
			},
		},
	},
	circle: {
		fontSize: '14px',
		fontFamily: 'Mulish',
		width: '24px',
		minWidth: '24px',
		height: '24px',
		borderRadius: '50%',
		display: 'flex',
		color: '#E55200',
		alignItems: 'center',
		justifyContent: 'center',
		border: '1px solid #E55200',
	},
	flexs: {
		display: 'flex',
		alignItems: 'center',
		minWidth: '130px',
		'@media(max-width:599px)': {
			justifyContent: 'center',
		},
	},
	flx: {
		'@media(max-width:599px)': {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			minWidth: '130px',
			justifyContent: 'center',
		},
	},
	flexs2: {
		display: 'flex',
		marginTop: '14px',
		alignItems: 'center',
		minWidth: '130px',
		'@media(max-width:599px)': {
			justifyContent: 'start',
		},
	},
	circle2: {
		fontSize: '14px',
		fontFamily: 'Mulish',
		minWidth: '24px',
		maxWidth: '24px',
		maxHeight: '24px',
		minHeight: '24px',
		width: '24px',
		height: '24px',
		borderRadius: '50%',
		display: 'flex',
		color: 'white',
		backgroundColor: '#E55200',
		alignItems: 'center',
		justifyContent: 'center',
		border: '1px solid #E55200',
		fontWeight: '600',
	},
	circleDisabled: {
		fontSize: '14px',
		fontFamily: 'Mulish',
		minWidth: '24px',
		maxWidth: '24px',
		maxHeight: '24px',
		minHeight: '24px',
		width: '24px',
		height: '24px',
		borderRadius: '50%',
		display: 'flex',
		//color: '#000',
		backgroundColor: '#DEDEDE',
		alignItems: 'center',
		justifyContent: 'center',
		fontWeight: '500',
	},
	backgroundTurquoise: {
		backgroundColor: 'transparent',
		width: '25px',
		marginTop: '8px',
	},
	divTurqoise: {
		width: '38px',
		height: '38px',
		backgroundColor: '#FFD984',
		borderTopLeftRadius: '10px',
		borderBottomLeftRadius: '10px',
		alignItems: 'center',
		'@media(max-width:600px)': {
			display: 'flex',
			width: '50px',
			height: '50px',
			fontSize: '1.1rem',
			alignItems: 'center',
			justifyContent: 'center',
		},
	},
	btnCampoFirma: {
		backgroundColor: '#F3F3F3',
		marginBottom: '16px',
		textTransform: 'none',
		// maxWidth: "183px",
		minWidth: '130px',
		height: '40px',
		border: '1px solid #C9C9C9',
		borderRadius: '10px',
		justifyContent: 'space-between',
		fontSize: '14px',
		padding: '0',
		paddingRight: '8px',
		'@media(max-width:600px)': {
			width: '100%',
			height: '50px',
			fontSize: '1.1rem',
		},
	},
	parr: {
		fontSize: '14px',
		color: '#4F4F4F',
		fontFamily: 'mulish',
		wordSpacing: '0.30em',
	},
	miniContainer: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		maxHeight: '600px',
		boxSizing: 'border-box',
		width: '100%',
		'@media(max-width:920px)': {
			display: 'none',
		},
	},
	none: {
		'@media(max-width:959px)': {
			display: 'none',
		},
	},
});

const runTextScript = text => {
	const s = document.createElement('script');
	s.type = 'text/javascript';
	s.async = true;
	s.innerHTML = text;
	document.body.appendChild(s);
	document.body.removeChild(s);
};

const SignerCF = props => {
	const {
		history,
		refresh,
		sizeFiles,
		isP7,
		style,
		rows,
		selected,
		//setStateFirmas,
	} = props;
	const CryptoJS = require('crypto-js');
	const key = APP_KEY;
	const urlData = localStorage.getItem('URL_Circuito');
	const cifrado = JSON.parse(urlData);
	const procesar = cifrado.replace(/[-]/g, '+').replace(/[_]/g, '/');
	let decifrado = CryptoJS.AES.decrypt(procesar, key);
	let salida = decifrado.toString(CryptoJS.enc.Utf8);
	const newIdCircuito = salida.split('&')[0].split('=')[1];
	const newIdFirmante = salida.split('=')[2];
	const [statusModaltoken, setStatusModaltoken] = useState(false);
	const [statusModalAlert, setStatusModalAlert] = useState(false);
	const [data, setData] = useState(null);
	const [files, setFiles] = useState();
	const [ruta, setRuta] = useState();
	const [size, setSize] = useState();
	const classes = useStyle();
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const states = useSelector(state => state.CircuitoFirmasReducer);
	const statesSign = useSelector(state => state.sign);
	const idPdfContainer = 'tttttcontainer';
	const modalRejects = states.modalReject;
	const modalConfirmRejects = states.modalConfirmReject;
	const modalUpss = states.modalUps;
	const modalSignatureRejects = states.modalSignatureReject;
	const modalMissingSignature = states.modalMissingSignatures;
	const modalSigns = states.modalSign;
	const [imgSign, setImgSign] = useState(null);
	const [currentDoc, setCurrentDoc] = useState(0);
	const [imageSignature, setImageSignature] = useState([]);
	const [isReSign, setReSign] = useState(false);
	const [predefinedSource, setPredefinedSource] = useState(false);
	const [verManuscritaDisable, setVerManuscritaDisable] = useState(false);
	const [disabledBtnsPdf, setDisabledBtnsPdf] = useState(false);
	const [signFields, setSignFields] = useState([]);
	const [isDataLoaded, setIsDataLoaded] = useState(false);
	const [configQR, setConfigQR] = useState({
		title: '',
		url: false,
		tPaginas: false,
	});
	const [sendData, setSendData] = useState({
		signerClientId: null,
		firmaelectronica: null,
		key: null,
		documents: [],
	});
	const [modalPantallaCarga, setModalPantallaCarga] = useState(false);
	const [checks, setChecks] = useState(false);
	const [personaEliminada, setPersonaEliminada] = useState(false);
	const [message, setMessage] = useState('');
	const [signPredefined, setSignPredefined] = useState(0);
	const [addDataCert, setAddDataCert] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [isDigitalSign, setDigitalSign] = useState(false);
	const [isQR, setQR] = useState(false);
	const [showComplete] = useState(true);
	const [digitalImg, setDigitalImg] = useState(null);
	const manuscrita = 'manuscrita';
	const digital = 'digital';
	const estampa = 'estampa';
	const marcaAgua = 'marcaagua';
	const [services, setServices] = useState({
		sms: false,
		whatsapp: false,
	});
	const qr = 'qr';
	const [isStamp, setStamp] = useState(false);
	const [isMarcaAgua, setMarcaAgua] = useState(false);
	const [numerodocumentos, setNumeroDocumentos] = useState(0);
	const [scale, setScale] = useState(0.8);
	const [verManuscrita, setVerManuscrita] = useState(false);
	const [typeImg, setTypeImg] = useState(manuscrita);
	const [tieneFirmaDigital, setTieneFirmaDigital] = useState(false);
	const firmado = states.modalFinished;
	const idThumbnailsContainer = 'idThumbnailsContainer';
	const [firmas, setFirmas] = useState([]);
	const [docs, setDocs] = useState();
	const [loading, setLoading] = useState(true);
	const [statusModal, setStatusModal] = useState(false);
	const [infoModal, setInfoModal] = useState({});
	const [firmaLibre, setFirmaLibre] = useState();
	const [firmaManuscrita, setFirmaManuscrita] = useState();
	const [correoCreador, setCorreoCreador] = useState();
	const [firmantes, setFirmantes] = useState();
	const token = localStorage.getItem('JWT');
	const [statusModalSign, setStatusModalSign] = useState(false);
	const [ultimaPosicion, setUltimaPosicion] = useState(false);
	const state = useSelector(state => state);
	const loadingRedux = state.sign.loading;
	const [s3Limit] = useState(4);
	const [modalManuscrita, setModalManuscrita] = useState(false);
	const historys = useHistory();
	const [firmasNecesarias, setfirmasNecesarias] = useState(0);
	const [firmasHechas, setFirmasHechas] = useState(0);
	const [todosLosCampos, setTodosLosCampos] = useState(false);
	const [aplicados, setAplicados] = useState(true);
	const [justBringImage, setJustBringImage] = useState(false);
	const [currentPositionSign, setCurrentPositionSign] = useState('');
	const [totaPositionSign, setTotaPositionSign] = useState([]);
	const [campoFirma, setCampoFirma] = useState(false);
	const userInfo = useSelector(({ auth }) => auth.userInfo.email);
	const userDigitalWare = useSelector(
		({ auth }) => auth.userInfo.userDigitalWare
	);
	const [mxSignOnScreen, setMxSignOnScreen] = useState(1);
	const [mnSignOnScreen, setMnSignOnScreen] = useState(1);
	const [errorsS3, setErrorsS3] = useState();
	const [numeroFaltante, setNumeroFaltante] = useState();
	const [redireccionar, setRedireccionar] = useState(false);
	const [lineal, setLineal] = useState(false);
	const [targetId, setTargetId] = useState('');
	const [firmarEjecutado, setFirmarEjecutado] = useState(false);
	const [vencimiento, setVencimiento] = useState({
		vence: false,
		fechaVence: false,
	});
	const imgFirma =
		statesSign.listManuscrita.length >= 1
			? statesSign.listManuscrita[0].base64
			: false;

	const obtenerData = () => {
		let archivos = [];
		if (data) {
			data.documentos.map((doc, index) => {
				let newArchivo = {
					id: index + 1,
					nombre: doc.nombreReal,
					nombrerepositorio: doc.nombre,
					repositorio: 1,
					ruta: doc.location,
				};
				archivos.push(newArchivo);
			});
			return archivos;
		}
	};

	useEffect(() => {
		setLoading(true);
		if (data) {
			const getData = async () => {
				let response = await dispatch(
					getFilesCF(obtenerData(), enqueueSnackbar, history)
				);
				if (response) {
					setRuta(response.ruta);
					setLoading(false);
					setDocs(response.files);
					setFiles(response.files);
					setSize(response.filesSize);
				} else {
					enqueueSnackbar(`ocurrio un error al cargar los archivos`, {
						style: { whiteSpace: 'pre-line' },
						variant: 'error',
						anchorOrigin: {
							vertical: 'top',
							horizontal: 'right',
						},
					});
					historys.push('/home');
				}
			};
			getData();
		}
	}, [data]);

	useEffect(() => {
		const consultar = async token => {
			let myHeaders = new Headers();
			myHeaders.append('Authorization', 'Bearer ' + token);
			myHeaders.append('Content-Type', 'application/json');
			let raw = JSON.stringify({
				circuito: newIdCircuito,
				firmante: newIdFirmante,
				clientfirmaya: true,
			});
			let requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow',
			};
			try {
				const response = await fetch(
					API_HOSTNAME_AWS + 'webCircuit/api/Signatory',
					requestOptions
				);
				const result_1 = await response.json();
				setData(result_1);
				setLineal(result_1.circuito.tipoCircuito === 'lineal' ? true : false);
				setFirmaLibre(result_1.firmante.firmaLibre);
				setFirmaManuscrita(result_1.firmante.firmaManuscrita);
				setCorreoCreador(result_1.circuito.correoCreador);
				if (userInfo !== result_1.firmante.correo) {
					enqueueSnackbar(
						'El documento que estás intentando firmar no corresponde a este usuario, por favor cierra la sesión activa e inténtalo de nuevo',
						{
							variant: 'info',
							anchorOrigin: {
								vertical: 'top',
								horizontal: 'right',
							},
						}
					);
					historys.push('/home');
				}
				setVencimiento({
					vence: result_1.circuito.vence,
					fechaVence: result_1.circuito.fechaVence,
				});
				const infirmantes = result_1.inFirmantes.filter(
					firm => firm.estado != 5
				);
				let list = [];
				for (let i = 0; i < infirmantes.length; i++) {
					list.push(infirmantes[i]);
				}

				list.push({
					email: result_1.firmante.correo,
					estado: result_1.firmante.estadoFirmaUsuario,
					nombre: result_1.firmante.nombres + ' ' + result_1.firmante.apellidos,
					posicion: result_1.firmante.posicion,
					esAprobador: result_1.firmante.esAprobador,
					esObservador: result_1.firmante.esObservador,
				});
				list.sort(function (a, b) {
					return a.posicion - b.posicion;
				});
				setFirmantes(list);
				const imgB64 = imgFirma
					? `data:image/png;base64,${imgFirma}`
					: `data:image/png;base64,${IMAGEN_FIRMA_PREDEF}`;
				if (result_1.firmante.firmaLibre === false) {
					const modificados = signFields.map(field => {
						if (totaPositionSign.includes(field.idReSign)) {
							return {
								...field,
								typeImg: 'png',
								imgRoute: imgB64,
								colorFirmante: 'transparent',
								source: 'campoFirmado',
							};
						}
						return field;
					});

					setSignFields(modificados);
					replaceImageField(totaPositionSign, modificados);
				}

				if (result_1.circuito.tipoCircuito === 'lineal') {
					// Filtrar los firmantes que no son observadores
					const firmantesNoObservadores = result_1.inFirmantes.filter(
						firmante => firmante.esObservador === 0
					);

					// Verificar si la posición del firmante actual es la última entre los firmantes no observadores
					if (
						firmantesNoObservadores.length + 1 ===
						result_1.firmante.posicion
					) {
						setUltimaPosicion(true);
					} else {
						setUltimaPosicion(false);
					}
				}
				if (result_1.firmante.esObservador === 0) {
					switch (result_1.firmante.estadoFirmaUsuario) {
						case 2:
							// setLoadin
							setModalPantallaCarga(true);
							setMessage('¡Este documento ya lo firmaste!');
							setChecks(true);
							break;
						case 4:
							// setLoading(false)
							setModalPantallaCarga(true);
							setMessage('¡Este documento ya ha sido rechazado por ti!');
							setChecks(true);
							break;
						case 5:
							// setLoading(false)
							setModalPantallaCarga(true);
							setMessage('¡Has sido eliminado de este circuito de firmas!');
							setPersonaEliminada(true);
							break;
						case 6:
							// setLoading(false)
							setModalPantallaCarga(false);
						default:
							break;
					}
				}
			} catch (error) {
				console.error("Ocurrio un error',error");
				return console.log('Ocurrio un error al consultar');
			}
		};
		consultar(token);
	}, []);

	useEffect(() => {
		if (data?.firmante !== undefined) {
			setIsDataLoaded(true);
		}
	}, [data]);

	useEffect(() => {
		document.body.className = 'bodyMiddle';
		let count = 0;
		let documentos = [];
		let documentosCargados = 0;
		setFirmas([]);
		runTextScript(
			"initPdfComponent('" +
				idPdfContainer +
				"','" +
				idThumbnailsContainer +
				"')"
		);
		if (docs?.length > 0) {
			docs.map(doc => {
				const reader = new FileReader();
				reader.numDoc = count;
				reader.filename = doc.name;
				reader.nombre = doc.nombre; // linea nueva
				reader.readAsDataURL(doc);
				reader.onload = event => {
					var document = new Object();
					document.uuid = event.target.numDoc;
					document.fileName = event.target.filename;
					document.nombre = doc.nombre; // linea nueva
					document.base64 = event.target.result.replace(
						'data:' + doc.type + ';base64,',
						''
					);
					document.typeSignature = [];
					document.listSigns = getListSignature(document.base64);
					documentos.push(document);
					documentosCargados++;

					if (documentosCargados >= docs.length) {
						documentos.sort((doc1, doc2) =>
							doc1.uuid > doc2.uuid ? 1 : doc1.uuid < doc2.uuid ? -1 : 0
						);
						let newSenData = { ...sendData };
						newSenData.documents = documentos;
						if (!isReSign) setSendData(newSenData);
						runTextScript(
							'loadDocuments(' +
								scale +
								",'" +
								JSON.stringify(documentos) +
								"')"
						);
					}
					setNumeroDocumentos(documentosCargados);
				};
				count++;
			});
		}
		setLoading(false);
		setTimeout(() => {
			setDisabledBtnsPdf(false);
		}, 1500);
	}, [scale, docs]);

	useEffect(() => {
		if (data && sendData.documents.length > 0 && !firmarEjecutado) {
			const imgB64 = imgFirma
				? `data:image/png;base64,${imgFirma}`
				: `data:image/png;base64,${IMAGEN_FIRMA_PREDEF}`;
			firmarConCamposInicial(imgB64);
			setFirmarEjecutado(true);
		}
	}, [data, sendData, firmarEjecutado]);

	useEffect(() => {
		dispatch(getManuscritaByUser(enqueueSnackbar));
	}, []);

	useEffect(() => {
		const contador = signFields.reduce((total, item) => {
			if (item.source === 'campoVacio') {
				return total + 1;
			} else {
				return total;
			}
		}, 0);

		setNumeroFaltante(contador);
	}, []);

	useEffect(() => {
		// Recorrer el array de documentos para contar las ubicaciones que requieren firma
		let cantidadFirmasNecesarias = 0;
		if (data) {
			data.documentos.forEach(documento => {
				if (documento.manuscrita && documento.manuscrita.length > 0) {
					cantidadFirmasNecesarias += documento.manuscrita.length;
				}
			});
			if (cantidadFirmasNecesarias > 0) {
				setCampoFirma(true);
			}
			setfirmasNecesarias(cantidadFirmasNecesarias);
		}
	}, [data]);

	const cerrarModal = a => {
		dispatch(modalSign(a));
	};
	const onClose = type => {
		setStatusModal(false);
		setStatusModaltoken(false);
		if (refresh != undefined) refresh(type);
	};

	const assistant = () => {
		setStatusModalSign(false);
		setStatusModaltoken(true);
		setStatusModal(true);
	};

	const terminaFirma = redirect => {
		runTextScript('hideLoadingPDF()');

		setLoading(false);
		if (!redirect) {
			historys.push('/home');
		}
	};

	const onMouseUp = oImg => {
		let offX;
		let offY;
		let uuid;
		let centerImgX = oImg._posX + oImg._imgWidth / 2;
		let centerImgY = oImg._posY + oImg._imgHeight / 2;
		let pdfPages = document.getElementsByClassName('pdf-canvas');
		let oPage = {
			top: null,
			left: null,
			width: null,
			height: null,
		};
		let oFirma = {
			id: oImg._id,
			signatureType: oImg._type,
			signPredefined: 0,
			addDataCert: 0,
			base64Image: null,
			tpag: configQR.tPaginas,
			url: configQR.url,
			title: configQR.title,
			posXY: {
				pageNumber: null,
				x: null,
				y: null,
				width: null,
				height: null,
				pageWidth: null,
				pageHeight: null,
			},
		};
		for (let a = 0; a < pdfPages.length; a++) {
			oPage.top = pdfPages[a].offsetTop;
			oPage.left = pdfPages[a].offsetLeft;
			if (window.innerWidth < 1253) {
				oPage.pageWidth = pdfPages[a].scrollWidth;
				oPage.pageHeight = pdfPages[a].scrollHeight;
			} else {
				oPage.pageWidth = pdfPages[a].width;
				oPage.pageHeight = pdfPages[a].height;
			}
			if (
				centerImgY > oPage.top &&
				centerImgY < oPage.top + oPage.pageHeight &&
				centerImgX > oPage.left &&
				centerImgX < oPage.left + oPage.pageWidth
			) {
				offX = pdfPages[a].offsetLeft;
				offY = pdfPages[a].offsetTop;

				uuid = pdfPages[a].getAttribute('data-doc');
				oFirma.idimg = oImg._id;
				oFirma.base64Image =
					oImg._type === qr
						? 'iVBORw0KGgoAAAANSUhEUgAAAIQAAACEAQMAAABrihHkAAAABlBMVEX///8AAABVwtN+AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAyElEQVRIie2Uyw3DMAxDtQH335IbsKKdBO2lRcQeIxiC/A6M9UvVYz9MEu2PYEzak6DIFc+JYzTbMCb1ByJCMfFBqT5yv09c8GUfvbhPbND5ujmxqD/A6qoFRHCGLv6V6YisidISVUZQ6OOEKyD9stZtR4AB6YIBHigPZ0B8bc2WPjOdka0rgVdPR6Tv3P8RVUK2evmJYEC8IHDVmZE1kNouIl5c35UT/7B7fY/U58Tt49q7gLjwlM61mxJXvmMn+taL++SxL/YC+rrZ93htqY0AAAAASUVORK5CYII='
						: oImg._imgBase64.replace('data:image/png;base64,', '');
				oFirma.signPredefined = signPredefined;
				oFirma.addDataCert = addDataCert;
				oFirma.posXY.pageNumber = pdfPages[a].getAttribute('data-pag');
				oFirma.posXY.pageHeight = oPage.pageHeight;
				oFirma.posXY.pageWidth = oPage.pageWidth;
				oFirma.posXY.x = oImg._posX - offX;
				oFirma.posXY.y = oImg._posY - offY;
				oFirma.posXY.width = oImg._imgWidth;
				oFirma.posXY.height = oImg._imgHeight;
				setCurrentPage(pdfPages[a].getAttribute('data-pag'));
				break;
			}
		}
		// let newSenData = { ...sendData };
		// let newFirmas = [];
		// let firma;
		// let existe = false;
		for (let i = 0; i < sendData.documents.length; i++) {
			const documento = sendData.documents[i];
			const firmas = documento.typeSignature;

			// Verificar si alguna firma tiene el mismo id que oFirma
			for (let j = 0; j < firmas.length; j++) {
				const firma = firmas[j];
				if (firma.id === oFirma.id) {
					// Eliminar la firma del documento actual
					firmas.splice(j, 1);

					// Como encontramos y manejamos la firma, salimos de la función
				}
			}

			// Verificar si el documento actual es el documento de destino
			if (documento.uuid === Number(uuid)) {
				// Agregar la firma al documento de destino
				documento.typeSignature.push(oFirma);
			}
		}
		if (
			oImg._posX - offX + oImg._imgWidth > oFirma.posXY.pageWidth ||
			oImg._posX - offX === 'NAN' ||
			oImg._posX - offX < 0 ||
			oImg._posY - offY + oImg._imgHeight > oFirma.posXY.pageHeight ||
			oImg._posY - offY < 0
		) {
			enqueueSnackbar(
				'La posicion del campo de firma seleccionado supera los limites de la pagina actual',
				{
					variant: 'info',
					anchorOrigin: {
						vertical: 'top',
						horizontal: 'right',
					},
				}
			);
		}

		let totaElem = document.getElementsByClassName('pdf-canvas');
		let acumData = 0;
		let listPost = [];
		for (var i = 0; i < totaElem.length; i++) {
			let resPo = totaElem[i].id.split('_');
			let docv = Number(resPo[1]);
			let pagv = Number(resPo[2]);
			let arrd = { d: docv, p: pagv, v: acumData }; //Identifico en donde empieza cada pg
			acumData += totaElem[i].height;
			listPost.push(arrd);
		}

		let fProps = {
			source: 'libre',
			pageWidth: oFirma.posXY.pageWidth,
			idReSign: oImg._id,
			posY: oImg._posY,
			posX: oImg._posX,
			reSignWidth: oImg._imgWidth,
			reSignHeigth: oImg._imgHeight,
			imgRoute: oImg._imgBase64,
			onclick: assignSignatureImage,
			typeImg: oImg._type,
			idPdfContainer: idPdfContainer,
			deleteSign: deleteSign,
		};

		let objetoExistente = false;

		if (signFields.length > 0) {
			objetoExistente = signFields.find(
				obj => obj.idReSign === fProps.idReSign
			);
		}
		if (objetoExistente) {
			const nuevosSignFields = signFields.map(obj =>
				obj.idReSign === fProps.idReSign ? fProps : obj
			);
			setSignFields(nuevosSignFields);
		} else {
			setSignFields([...signFields, fProps]);
		}
		refreshDoc();
	};

	function deleteSign(e, idDelete) {
		let id;
		idDelete ? (id = idDelete) : (id = e.target.id.replace('btn-', ''));
		let newSendData = [];
		let listDocs = [];
		newSendData.signerClientId = sendData.signerClientId;
		newSendData.key = encriptar(sendData.key, APP_KEY);
		document.getElementById('container-' + id).remove();
		sendData.documents.map(document => {
			let listSignatures = [];
			document.typeSignature.map(type => {
				if (type.idimg) {
					if (type.idimg != id) {
						listSignatures.push(type);
					}
				} else {
					listSignatures.push(type);
				}
			});
			document.typeSignature = listSignatures;
			listDocs.push(document);
		});

		const newSignFields = signFields.filter(
			field => field.idReSign !== idDelete
		);
		setSignFields(newSignFields);
		newSendData.documents = listDocs;
		setSendData(newSendData);
		setVerManuscritaDisable(false);
		refreshDoc();
	}

	const abrirModalfinalizar = () => {
		dispatch(modalFinished(true));
	};

	const signApply = (signerClientId, key, codeId, isElectronic) => {
		if (signerClientId == 'Token' && key == 'Token') {
			sendData.key = null;
			sendData.signerClientId = null;
			sendData.documents.map(data => {
				data.typeSignature.map((signature, index) => {
					signature.id = index;
				});
			});
			runTextScript('showLoadingPDF()');
			setStatusModal(false);
			setLoading(true);
			dispatch(
				firmaAvanzadaTokenCF(
					sendData,
					enqueueSnackbar,
					terminaFirma,
					assistant,
					data.documentos,
					data.circuito.id,
					data.firmante.id,
					ultimaPosicion,
					abrirModalfinalizar
				)
			);
		} else {
			sendData.signerClientId = signerClientId;
			sendData.key = encriptar(key, APP_KEY);
			sendData.firmaelectronica = isElectronic ? true : null;
			sendData.codeId = isElectronic ? codeId : null;
			sendData.documents.map(data => {
				data.typeSignature.map((signature, index) => {
					signature.id = index;
					if (
						signature.signatureType == 'manuscrita' ||
						signature.signatureType == 'qr'
					) {
						if (window.innerWidth <= 1253) {
							signature.posXY.pageHeight =
								document.getElementsByClassName('pdf-canvas')[0].scrollHeight;
							signature.posXY.pageWidth =
								document.getElementsByClassName('pdf-canvas')[0].scrollWidth;
						}
					}
				});
			});
			runTextScript('showLoadingPDF()');
			setStatusModalSign(false);
			if (size > s3Limit * 1024 || (isElectronic && style)) {
				SignCustomWithoutdocumentS3(
					sendData,
					enqueueSnackbar,
					setStatusModalAlert,
					terminaFirma
				);
			} else {
				SignCustomWithoutdocument(
					sendData,
					enqueueSnackbar,
					setStatusModalAlert,
					terminaFirma
				);
			}
		}
	};
	const aplicarFirma = (state, type) => {
		setReSign(false);
		let newSenData = { ...sendData };
		let cantidad = 0;
		if (type == marcaAgua && state === true) {
			newSenData.documents.map(doc => {
				cantidad += doc.listSigns.length;
			});
		}
		if (cantidad == 0) {
			if (type == manuscrita) {
				if (verManuscritaDisable) {
					return;
				}
				let docAct = null;
				let listMini = document.getElementsByClassName('pdf-canvas-mini');
				if (listMini) {
					docAct = Array.from(listMini)
						.find(mini => mini.classList.contains('active-sheet'))
						.getAttribute('data-documento');
				}
				setTypeImg(manuscrita);
				let doc = sendData.documents[docAct];
				if (doc.uuid == docAct) {
					if (doc.listSigns !== null && doc.listSigns.length > 0) {
						setDigitalSign(true);
						setTieneFirmaDigital(true);
					} else {
						setTieneFirmaDigital(false);
					}
				}
				setVerManuscrita(state);
				return;
			}
			let newFirmas = [];
			let firma;
			let oFirma = {
				signatureType: type,
				signPredefined: 0,
				addDataCert: 0,
			};
			let existe = false;
			if (state) {
				for (var a in newSenData.documents) {
					existe = false;
					for (var b in newSenData.documents[a].typeSignature) {
						firma = newSenData.documents[a].typeSignature[b];
						if (firma.signatureType == type) {
							existe = true;
						}
					}
					if (!existe) {
						// console.log("Holaaaa 23")
						newSenData.documents[a].typeSignature.push(oFirma);
					}
				}
			} else {
				for (var a in newSenData.documents) {
					newFirmas = [];
					for (var b in newSenData.documents[a].typeSignature) {
						firma = newSenData.documents[a].typeSignature[b];
						if (firma.signatureType == type) {
							continue;
						}
						newFirmas.push(firma);
					}
					newSenData.documents[a].typeSignature = newFirmas;
				}
			}
			setSendData(newSenData);
			switch (type) {
				case manuscrita:
					setVerManuscrita(state);
					break;
				case estampa:
					setStamp(state);
					break;
				case marcaAgua:
					setMarcaAgua(state);
					break;
			}
		} else {
			if (type == marcaAgua) {
				enqueueSnackbar(
					'Alguno de los documentos cargados tiene una firma por lo tanto no se le puede agregar marca de agua',
					{
						variant: 'info',
						anchorOrigin: {
							vertical: 'top',
							horizontal: 'right',
						},
					}
				);
			}
		}
	};

	const refreshDoc = e => {
		let docAct = null;
		let listMini = document.getElementsByClassName('pdf-canvas-mini');
		if (listMini) {
			docAct = Array.from(listMini)
				.find(mini => mini.classList.contains('active-sheet'))
				.getAttribute('data-documento');
		}
		if (e && e.target && e.target.getAttribute('documento')) {
			docAct = e.target.getAttribute('documento');
		}
		if (docAct != null) {
			setVerManuscritaDisable(false);
			setDigitalSign(false);
			setQR(false);
			let doc = sendData.documents[docAct];
			if (doc.listSigns !== null && doc.listSigns.length > 0) {
				for (var j = 0; j < doc.typeSignature.length; j++) {
					switch (doc.typeSignature[j].signatureType) {
						case manuscrita:
							setVerManuscritaDisable(true);
							setDigitalSign(true);
							break;
						case qr:
							setQR(true);
							break;
					}
				}
			}
			if (doc.typeSignature.length > 0) {
				for (var i = 0; i < doc.typeSignature.length; i++) {
					switch (doc.typeSignature[i].signatureType) {
						case digital:
							setDigitalSign(true);
							break;
						case qr:
							setQR(true);
							break;
					}
				}
			}
		}
		aplicarCampos();
	};

	// this is the functionality for when another file is selected in the mini list
	const handlerChange = async () => {
		let archivo = document.getElementById('Upload').files;
		if (archivo[0] != null) {
			await getPageNumber(archivo);
			var fileSizeMb = Math.round(archivo[0].size / 1024);
			var maxSizeMb = Math.round((MAX_MEGAS_FILE_SIZE * 1000000) / 1024);
			archivo[0].sizeBytes = archivo[0].size;
			var extension = '.' + archivo[0].name.split('.').pop();
			if (!extension.toLowerCase().includes('.pdf')) {
				enqueueSnackbar(
					`El archivo ${archivo[0].name} no es permitido, los tipos de archivos permitidos son: .pdf`,
					{
						style: { whiteSpace: 'pre-line' },
						variant: 'error',
						anchorOrigin: {
							vertical: 'top',
							horizontal: 'right',
						},
					}
				);
			} else if (docs.length == 10) {
				enqueueSnackbar(
					`La cantidad de archivos supera el máximo permitido de 10 documentos.`,
					{
						style: { whiteSpace: 'pre-line' },
						variant: 'error',
						anchorOrigin: {
							vertical: 'top',
							horizontal: 'right',
						},
					}
				);
			} else {
				if (fileSizeMb > maxSizeMb) {
					enqueueSnackbar(
						`El tamaño del archivo ${
							archivo[0].name
						} supera el máximo permitido.\nTamaño limite de ${kbToMb(
							MAX_MEGAS_FILE_SIZE * 1000000
						)}`,
						{
							style: { whiteSpace: 'pre-line' },
							variant: 'error',
							anchorOrigin: {
								vertical: 'top',
								horizontal: 'right',
							},
						}
					);
				} else {
					let dropedSize = 0;
					docs.map(file => {
						var sizekiloByte = Math.round(file.size / 1024);
						dropedSize += sizekiloByte;
					});
					let maxFilesSizeMb = Math.round(
						(MAX_MEGAS_FILES_SIZE * 1000000) / 1000
					);
					dropedSize += fileSizeMb;
					if (dropedSize > maxFilesSizeMb) {
						enqueueSnackbar(
							`El tamaño total de los archivos supera el máximo permitido.\nTamaño limite de ${kbToMb(
								MAX_MEGAS_FILES_SIZE * 1000000
							)}`,
							{
								style: { whiteSpace: 'pre-line' },
								variant: 'error',
								anchorOrigin: {
									vertical: 'top',
									horizontal: 'right',
								},
							}
						);
					} else {
						var results = docs.filter(function (doc) {
							return doc.name == archivo[0].name;
						});
						var existe = results.length > 0 ? results[0] : null;
						if (existe != null) {
							enqueueSnackbar(
								`El archivo ${archivo[0].name} se encuentra actualmente agregado`,
								{
									style: { whiteSpace: 'pre-line' },
									variant: 'error',
									anchorOrigin: {
										vertical: 'top',
										horizontal: 'right',
									},
								}
							);
						} else {
							var filesList = [];
							props.files.map(file => {
								filesList.push(file);
							});
							var newdoc = docs;
							newdoc.push(archivo[0]);
							filesList.push(archivo[0]);
							props.setFiles(filesList);
							setDocs(newdoc);
							document.getElementById('Upload').files = null;
							// updateDocuments();
						}
					}
				}
			}
		}
	};
	async function getPageNumber(pFiles) {
		var validFiles = [];
		for await (const pFile of pFiles) {
			if (pFile.numPages === undefined) {
				if ('.' + pFile.name.split('.').pop() == '.pdf') {
					try {
						const arrayBuffer = await readFile(pFile);
						const pdf = await PDFDocument.load(arrayBuffer);
						pFile.numPages = pdf.getPages().length;
						validFiles.push(pFile);
					} catch (error) {
						enqueueSnackbar(
							`El archivo ${pFile.name} está protegido y no es posible hacerle cambios`,
							{
								style: { whiteSpace: 'pre-line' },
								variant: 'error',
								anchorOrigin: {
									vertical: 'top',
									horizontal: 'right',
								},
							}
						);
					}
				} else {
					pFile.numPages = 0;
					validFiles.push(pFile);
				}
			}
		}
	}
	const readFile = file => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
			reader.readAsArrayBuffer(file);
		});
	};

	const handleClickItem = (ltv, estampa) => {
		let data = [];
		let showAlert = true; // Variable para controlar la ejecución de la alerta
		for (let i = 0; i < sendData.documents.length - 1; i++) {
			if (sendData.documents[i].typeSignature.length > 0) {
				for (let j = 0; j < sendData.documents[i].typeSignature.length; j++) {
					if (
						sendData.documents[i].typeSignature[j].signatureType !== 'marcaagua'
					) {
						if (
							sendData.documents[i].typeSignature[j].posXY.x +
								sendData.documents[i].typeSignature[j].posXY.width >
								sendData.documents[i].typeSignature[j].posXY.pageWidth ||
							sendData.documents[i].typeSignature[j].posXY.x === 'NAN' ||
							sendData.documents[i].typeSignature[j].posXY.x < 0 ||
							sendData.documents[i].typeSignature[j].posXY.y < 0 ||
							sendData.documents[i].typeSignature[j].posXY.y +
								sendData.documents[i].typeSignature[j].posXY.height >
								sendData.documents[i].typeSignature[j].posXY.pageHeight
						) {
							enqueueSnackbar(
								'La posición del campo de firma seleccionado supera los límites de la página actual',
								{
									variant: 'error',
									anchorOrigin: {
										vertical: 'top',
										horizontal: 'right',
									},
								}
							);
							showAlert = false; // No se ejecutará la alerta
						}
					}
				}
			}
		}
		if (showAlert) {
			if (numeroFaltante > 0) {
				dispatch(modalMissingSignatures(true));
			} else {
				//Verificar si es firmanteLibre
				if (firmaLibre) {
					const array = sendData.documents;
					const totalTypeSignatures = array.reduce((total, obj) => {
						return total + obj.typeSignature.length;
					}, 0);
					if (totalTypeSignatures > 0) {
						setInfoModal({
							ltv: Boolean(ltv),
							estampa: Boolean(estampa),
							files,
						});
						setStatusModal(true);
					} else {
						enqueueSnackbar('Debes insertar al menos una firma manuscrita', {
							variant: 'info',
							anchorOrigin: {
								vertical: 'top',
								horizontal: 'right',
							},
						});
					}
				} else {
					setInfoModal({
						ltv: Boolean(ltv),
						estampa: Boolean(estampa),
						files,
					});
					setStatusModal(true);
				}
			}
		}
	};

	//This is the button that contains the button to enlarge or reduce the document; the buttons to rotate the document are disabled, for the moment they will not be implemented
	const BotoneraEditar = props => {
		const reSign = async (scale, mode) => {
			props.reSignImage(scale, mode);
		};

		const zoomIn = () => {
			const doc = document.querySelector('.active-sheet');
			const idDoc = doc?.getAttribute('documento');
			const page = doc?.getAttribute('data-page');
			const pdfDoc = document.getElementById(`page_${idDoc}_${page}`);
			if (!disabledBtnsPdf) {
				setDisabledBtnsPdf(true);
				let newScale = 0;
				if (props.scale + 0.2 > 1.2) {
					setDisabledBtnsPdf(false);
					return;
				} else newScale = Math.round((props.scale + 0.2) * 100) / 100;
				reSign(newScale, true);
			}
		};

		const zoomOut = () => {
			const doc = document.querySelector('.active-sheet');
			const idDoc = doc.getAttribute('documento');
			const page = doc.getAttribute('data-page');
			const pdfDoc = document.getElementById(`page_${idDoc}_${page}`);
			if (!disabledBtnsPdf) {
				setDisabledBtnsPdf(true);
				let newScale = 0;
				if (props.scale - 0.2 < 0.7) {
					setDisabledBtnsPdf(false);
					return;
				} else newScale = Math.round((props.scale - 0.2) * 100) / 100;
				reSign(newScale, false);
			}
		};

		return (
			<Box className={classes.iconsPdf}>
				<img src={agrandar} className={classes.icon1Pdf} onClick={zoomIn} />
				<img src={alejar} className={classes.iconPdf} onClick={zoomOut} />
				{/* <img src={girarRight} className={classes.iconPdf} />
                <img src={girarLeft} className={classes.iconPdf} /> */}
			</Box>
		);
	};

	const reSignImage = (newScale, mode) => {
        setScale(newScale);
        setReSign(true);
        let newImageSignature = [];
   
        // Obtener el contenedor PDF
        let datComp = document.getElementById(idPdfContainer);
        let containerWidth = datComp?.clientWidth || 0;
       
        signFields.forEach(firmante => {
            let prevPageWidth = firmante.pageWidth;
            let pageWidth = (prevPageWidth / scale) * newScale;
            let scaleFactor = newScale / scale;
   
            //  Ajuste manual para evitar que se mueva a la izquierda/derecha
            let correctionFactorX = 1;  // MODIFICAR ESTE VALOR SI SIGUE MOVIÉNDOSE
            let adjustedPosX = (firmante.posX * scaleFactor) - correctionFactorX;
   
            //  Ajuste manual para evitar que suba o baje
            let correctionFactorY = 1;  //  MODIFICAR ESTE VALOR SI SE MUEVE ARRIBA/ABAJO
            let adjustedPosY = (firmante.posY * scaleFactor) - correctionFactorY;
   
            const newSignature = {
                pageWidth,
                idPdfContainer,
                onclick: assignSignatureImage,
                isFieldempty: true,
                isReSign: true,
                deleteSign: firmante.source === 'libre' && deleteSign,
                reSignWidth: firmante.reSignWidth * scaleFactor,
                reSignHeigth: firmante.reSignHeigth * scaleFactor,
                idReSign: firmante.idReSign,
                posX: adjustedPosX,  //  Ahora podemos ajustar manualmente la posición
                posY: adjustedPosY,  //  Lo mismo con la posición vertical
                imgRoute: firmante.source ? firmante.imgRoute : AddSignature,
                typeImg: firmante.source ? firmante.typeImg : 'png',
                colorFirmante: firmante.source === 'transparent',
            };
   
            Object.assign(firmante, newSignature);
            newImageSignature.push(newSignature);
        });
   
        setImageSignature(newImageSignature);
   
        newImageSignature.forEach(signature => {
            setImgSign(signature.imgRoute);
        });
    };
	
	const setSignImage = (imgB64, predefined) => {
		if (justBringImage) {
			if (todosLosCampos) {
				const modificados = signFields.map(field => {
					if (totaPositionSign.includes(field.idReSign)) {
						return {
							...field,
							typeImg: 'png',
							imgRoute: imgB64,
							colorFirmante: 'transparent',
							source: 'campoFirmado',
						};
					}
					return field;
				});

				setSignFields(modificados);
				replaceImageField(totaPositionSign, modificados);
			} else {
				const modificados = signFields.map(field => {
					if (field.idReSign === currentPositionSign) {
						return {
							...field,
							typeImg: 'png',
							imgRoute: imgB64,
							colorFirmante: 'transparent',
							source: 'campoFirmado',
						};
					}
					return field;
				});
				setSignFields(modificados);
				replaceImageField([currentPositionSign], modificados);
			}
		} else {
			if (predefined) {
				setPredefinedSource(true);
			}
			let docAct = null;
			let listMini = document.getElementsByClassName('pdf-canvas-mini');
			if (listMini) {
				docAct = Array.from(listMini)
					.find(mini => mini.classList.contains('active-sheet'))
					.getAttribute('data-documento');
			}
			let doc = sendData.documents[docAct];
			if (doc.listSigns !== null && doc.listSigns.length > 0) {
				setVerManuscritaDisable(true);
			}
			setImageSignature([
				{
					reSignWidth: 0,
					reSignHeigth: 0,
					idReSign: '',
					posX: 0,
					posY: 0,
					imgRoute: imgB64,
					typeImg: typeImg,
					deleteSign: deleteSign,
				},
			]);
			setVerManuscrita(false);
			setImgSign(imgB64);
		}
	};

	const firmarConCampos = (imgB64, type) => {
		if (firmasNecesarias >= 1 && todosLosCampos && type == 'manuscrita') {
			//recorrer el array de firmas para asignar la imagen modificar el sendData, cambiar el setFirmasHechas al total
			//Cada documento debe llevar el typeSignature con las posiciones que traemos del backend
			let newSenData = { ...sendData };
			let array1 = newSenData.documents;
			let array2 = data.documentos;
			let totalFirmas = 0; // inicializa la variable totalFirmas en cero
			for (let i = 0; i < array1.length; i++) {
				for (let j = 0; j < array2.length; j++) {
					if (
						array1[i].nombre === array2[j].nombre &&
						array2[j].manuscrita.length > 0
					) {
						array1[i].typeSignature = [];
						for (let k = 0; k < array2[j].manuscrita.length; k++) {
							let oFirma = {
								id: 'cvSign_' + new Date().getTime() + '_' + i + j + k,
								signatureType: 'manuscrita',
								signPredefined: 0,
								addDataCert: 0,
								base64Image: imgB64.replace('data:image/png;base64,', ''),
								tpag: false,
								url: false,
								title: '',
								posXY: {
									pageNumber: array2[j].manuscrita[k].pageNumber,
									x: array2[j].manuscrita[k].eje_x,
									y: array2[j].manuscrita[k].eje_y,
									width: array2[j].manuscrita[k].ancho,
									height: array2[j].manuscrita[k].alto,
									pageWidth: array2[j].manuscrita[k].pageWidth,
									pageHeight: array2[j].manuscrita[k].pageHeight,
								},
							};
							array1[i].signatureType = 'manuscrita';
							array1[i].typeSignature.push(oFirma);
						}
						totalFirmas += array1[i].typeSignature.length; // suma la cantidad de firmas en el objeto actual a la variable totalFirmas
					}
				}
			}
			setFirmasHechas(totalFirmas);
			newSenData.documents = array1;
		} else if (
			firmasNecesarias >= 1 &&
			!todosLosCampos &&
			type == 'manuscrita'
		) {
			// Aplicar la imagen en el sendData, cambiar el setFirmasHechas a +1
			let newSenData = { ...sendData };
			let array1 = newSenData.documents;
			let array2 = data.documentos;
			// Creamos un nuevo array para almacenar todas las manuscritas.
			const manuscritasTotales = [];
			for (let i = 0; i < array2.length; i++) {
				const documentoActual = array2[i];
				// Si el objeto actual tiene propiedades "manuscrita" y su longitud es mayor a cero, agregamos todas las manuscritas al array "manuscritasTotales"
				if (
					documentoActual.manuscrita &&
					documentoActual.manuscrita.length > 0
				) {
					manuscritasTotales.push(...documentoActual.manuscrita);
				}
			}
			// console.log("Holaaaaa24")
			setTimeout(() => {
				// Extraer los valores de x1 y x2
				const [_, x1, x2] = currentPositionSign
					.split('_')
					.map(x => parseInt(x));
				const objArray2 = array2.find(obj => obj.orden === x1);
				const objArray1 = array1.find(obj => obj.nombre === objArray2.nombre);
				// let posP = manuscritasTotales[x2 - 1].pageNumber - 1;
				// let posY =
				//   manuscritasTotales[x2 - 1].eje_y -
				//   manuscritasTotales[x2 - 1].pageHeight * posP;

				objArray1.typeSignature.push({
					id: 'cvSign_' + new Date().getTime(),
					signatureType: 'manuscrita',
					signPredefined: 0,
					addDataCert: 0,
					base64Image: imgB64.replace('data:image/png;base64,', ''),
					tpag: false,
					url: false,
					title: '',
					posXY: {
						pageNumber: manuscritasTotales[x2 - 1].pageNumber,
						x: manuscritasTotales[x2 - 1].eje_x,
						// y: posY,
						y: manuscritasTotales[x2 - 1].eje_y,
						width: manuscritasTotales[x2 - 1].ancho,
						height: manuscritasTotales[x2 - 1].alto,
						pageWidth: manuscritasTotales[x2 - 1].pageWidth,
						pageHeight: manuscritasTotales[x2 - 1].pageHeight,
					},
				});
			}, 10);
			newSenData.documents = array1;
			if (firmasNecesarias !== firmasHechas) {
				setFirmasHechas(prevFirmasHechas => prevFirmasHechas + 1);
			}
		}
		if (firmasNecesarias >= 1 && todosLosCampos && type == 'digital') {
			let newSenData = { ...sendData };
			let array1 = newSenData.documents;
			let array2 = data.documentos;
			let totalFirmas = 0; // inicializa la variable totalFirmas en cero
			for (let i = 0; i < array1.length; i++) {
				for (let j = 0; j < array2.length; j++) {
					if (
						array1[i].nombre === array2[j].nombre &&
						array2[j].manuscrita.length > 0
					) {
						array1[i].typeSignature = [];
						for (let k = 0; k < array2[j].manuscrita.length; k++) {
							let oFirma = {
								id: 'cvSign_' + new Date().getTime() + '_' + i + j + k,
								signatureType: 'manuscrita',
								signPredefined: 1,
								addDataCert: 0,
								base64Image:
									'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',
								tpag: false,
								url: false,
								title: '',
								posXY: {
									pageNumber: array2[j].manuscrita[k].pageNumber,
									x: array2[j].manuscrita[k].eje_x,
									y: array2[j].manuscrita[k].eje_y,
									width: array2[j].manuscrita[k].ancho,
									height: array2[j].manuscrita[k].alto,
									pageWidth: array2[j].manuscrita[k].pageWidth,
									pageHeight: array2[j].manuscrita[k].pageHeight,
								},
							};
							array1[i].signatureType = 'manuscrita';
							array1[i].typeSignature.push(oFirma);
						}
						totalFirmas += array1[i].typeSignature.length; // suma la cantidad de firmas en el objeto actual a la variable totalFirmas
					}
				}
			}
			setFirmasHechas(totalFirmas);
			newSenData.documents = array1;
		} else if (firmasNecesarias >= 1 && !todosLosCampos && type == 'digital') {
			// Aplicar la imagen en el sendData, cambiar el setFirmasHechas a +1
			let newSenData = { ...sendData };
			let array1 = newSenData.documents;
			let array2 = data.documentos;
			// Creamos un nuevo array para almacenar todas las manuscritas.
			const manuscritasTotales = [];
			for (let i = 0; i < array2.length; i++) {
				const documentoActual = array2[i];
				// Si el objeto actual tiene propiedades "manuscrita" y su longitud es mayor a cero, agregamos todas las manuscritas al array "manuscritasTotales"
				if (
					documentoActual.manuscrita &&
					documentoActual.manuscrita.length > 0
				) {
					manuscritasTotales.push(...documentoActual.manuscrita);
				}
			}
			// Extraer los valores de x1 y x2
			const [_, x1, x2] = currentPositionSign.split('_').map(x => parseInt(x));
			const objArray2 = array2.find(obj => obj.orden === x1);
			const objArray1 = array1.find(obj => obj.nombre === objArray2.nombre);
			let posP = manuscritasTotales[x2 - 1].pageNumber - 1;
			let posY =
				manuscritasTotales[x2 - 1].eje_y -
				manuscritasTotales[x2 - 1].pageHeight * posP;

			objArray1.typeSignature.push({
				id: 'cvSign_' + new Date().getTime(),
				signatureType: 'manuscrita',
				signPredefined: 1,
				addDataCert: 0,
				base64Image:
					'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',
				tpag: false,
				url: false,
				title: '',
				posXY: {
					pageNumber: manuscritasTotales[x2 - 1].pageNumber,
					x: manuscritasTotales[x2 - 1].eje_x,
					y: manuscritasTotales[x2 - 1].eje_y,
					width: manuscritasTotales[x2 - 1].ancho,
					height: manuscritasTotales[x2 - 1].alto,
					pageWidth: manuscritasTotales[x2 - 1].pageWidth,
					pageHeight: manuscritasTotales[x2 - 1].pageHeight,
				},
			});
			newSenData.documents = array1;
			if (firmasNecesarias !== firmasHechas) {
				setFirmasHechas(prevFirmasHechas => prevFirmasHechas + 1);
			}
		}
		setSignImage(imgB64, false);
	};

	const firmarConCamposInicial = imgB64 => {
		//Cada documento debe llevar el typeSignature con las posiciones que traemos del backend
		let newSenData = { ...sendData };
		let array1 = newSenData.documents;
		let array2 = data.documentos;
		let totalFirmas = 0; // inicializa la variable totalFirmas en cero
		for (let i = 0; i < array1.length; i++) {
			for (let j = 0; j < array2.length; j++) {
				if (
					array1[i].nombre === array2[j].nombre &&
					array2[j].manuscrita.length > 0
				) {
					array1[i].typeSignature = [];
					for (let k = 0; k < array2[j].manuscrita.length; k++) {
						let oFirma = {
							id: 'cvSign_' + new Date().getTime() + '_' + i + j + k,
							signatureType: 'manuscrita',
							signPredefined: imgFirma ? 0 : 1,
							addDataCert: 0,
							base64Image: imgB64.replace('data:image/png;base64,', ''),
							tpag: false,
							url: false,
							title: '',
							posXY: {
								pageNumber: array2[j].manuscrita[k].pageNumber,
								x: array2[j].manuscrita[k].eje_x,
								y: array2[j].manuscrita[k].eje_y,
								width: array2[j].manuscrita[k].ancho,
								height: array2[j].manuscrita[k].alto,
								pageWidth: array2[j].manuscrita[k].pageWidth,
								pageHeight: array2[j].manuscrita[k].pageHeight,
							},
						};
						array1[i].signatureType = 'manuscrita';
						array1[i].typeSignature.push(oFirma);
					}
					totalFirmas += array1[i].typeSignature.length; // suma la cantidad de firmas en el objeto actual a la variable totalFirmas
				}
			}
		}
		setFirmasHechas(totalFirmas);
		// documents = array1;
		return array1;
	};
	//Se lanza el modal para cargar la imagen de firma
	const assignSignatureImage = ind => {
		if (ind.target.tagName === 'CANVAS') {
			setTargetId(ind.target.id);
			let firId = ind.target.id;
			setCurrentPositionSign(firId);
			setJustBringImage(true);
			dispatch(modalSign(true));
		}
	};
	//Se asigna una imagen a uno o varios campos de firma disponibles
	function replaceImageField(idRepl, modificados) {
		if (idRepl.length == 1) {
			document.getElementById(`container-${idRepl.flat()}`).remove();

			const objBuscado = modificados.find(
				obj => obj.idReSign === `${idRepl.flat()}`
			);
			CanvasDragResize(objBuscado);
		} else {
			idRepl.forEach(id => {
				if (document.getElementById(`container-${id}`)) {
					document.getElementById(`container-${id}`).remove();
				}
			});

			modificados.forEach(mod => {
				CanvasDragResize(mod);
			});
		}
	}
	//Se cargan los campos para firmar al inicio del proceso
	function aplicarCampos() {
		let totaElem = document.getElementsByClassName('pdf-canvas');
		let acumData = 0;
		let listPost = [];
		if (aplicados) {
			let totNom = [];
			let datComp = document.getElementById(idPdfContainer);
			// let totaElem = document.getElementsByClassName('pdf-canvas');
			// let acumData = 0;
			// let listPost = [];

			if (datComp) {
				setAplicados(false);
				let posCamp = 1;
				data.documentos.map(doc => {
					doc.manuscrita.map(fir => {
						let maxMarIzq = 0;
						let finaPosX;
						let fProps;
						let tamaPage;
						let paginasAnteriores;
						let tamaMarg;
						let restPage;
						let finaPosY;
						let nomCamp;

						if (window.innerWidth <= 2000) {
							//fir es el recorrido de manuscrita (cada uno de los campos de firma)
							let anchoOriginalPagina;
							let altoOriginalPagina;
							let nuevoAnchoPagina; //Identificar en que pagina estoy y poner el dato aqui
							let nuevoAltoPagina;
							let anchoOriginalFirma;
							let altoOriginalFirma;
							let factorEscalaAncho;
							let factorEscalaAlto;
							let nuevoAnchoFirma;
							let nuevoAltoFirma;
							let posicionOriginalXFirma;
							let posicionOriginalYFirma;
							let nuevoEjeX;
							let nuevoEjeY;
							for (var i = 0; i < totaElem.length; i++) {
								let resPo = totaElem[i].id.split('_');
								let docv = Number(resPo[1]);
								let pagv = Number(resPo[2]);
								let ancho = totaElem[i].offsetWidth;
								let alto = totaElem[i].offsetHeight;
								let arrd = { d: docv, p: pagv, v: acumData, ancho, alto };
								acumData += totaElem[i].offsetHeight;
								listPost.push(arrd);
							}
							anchoOriginalPagina = fir.pageWidth;
							altoOriginalPagina = fir.pageHeight;
							nuevoAnchoPagina = listPost.find(
								a => a.d == doc.orden - 1 && a.p == fir.pageNumber
							).ancho; //Identificar en que pagina estoy y poner el dato aqui
							nuevoAltoPagina = listPost.find(
								a => a.d == doc.orden - 1 && a.p == fir.pageNumber
							).alto;
							anchoOriginalFirma = fir.ancho;
							altoOriginalFirma = fir.alto;
							factorEscalaAncho = nuevoAnchoPagina / anchoOriginalPagina;
							factorEscalaAlto = nuevoAltoPagina / altoOriginalPagina;
							nuevoAnchoFirma = anchoOriginalFirma * factorEscalaAncho;
							nuevoAltoFirma = altoOriginalFirma * factorEscalaAlto;
							posicionOriginalXFirma = fir.eje_x;
							posicionOriginalYFirma = fir.eje_y;
							nuevoEjeX = posicionOriginalXFirma * factorEscalaAncho;
							nuevoEjeY = posicionOriginalYFirma * factorEscalaAlto;

							if (datComp.clientWidth - nuevoAnchoPagina > 0) {
								maxMarIzq = (datComp.clientWidth - nuevoAnchoPagina) / 2;
							} else {
								maxMarIzq = 0;
							}
							paginasAnteriores =
								listPost.findIndex(
									a => a.d === doc.orden - 1 && a.p === fir.pageNumber
								) + 1;
							finaPosX =
								window.innerWidth <= 1252 ? nuevoEjeX : nuevoEjeX + maxMarIzq;
							tamaPage = listPost.find(
								a => a.d == doc.orden - 1 && a.p == fir.pageNumber
							).v;
							//tamaMarg = paginasAnteriores * 2 - 1; //Tengo esta margen (manuscrita.pagina * 2px 1px de arriba, y 1 px de abajo)le quito 1px porque el primer doc no lleva 1 px de la margen de arriba
							restPage = tamaPage;
							finaPosY = nuevoEjeY + restPage < 0 ? 0 : nuevoEjeY + restPage;
							nomCamp = 'cpf_' + doc.orden + '_' + posCamp;
							totNom.push(nomCamp);
							//identifico el documento y la pagina
							fProps = {
								source: 'campoVacio',
								pageWidth: nuevoAnchoPagina,
								isFieldempty: true,
								isReSign: true,
								idReSign: nomCamp,
								posY: finaPosY,
								posX: finaPosX,
								reSignWidth: nuevoAnchoFirma,
								reSignHeigth: nuevoAltoFirma,
								// imgRoute: AddSignature,
								imgRoute: imgFirma
									? `data:image/png;base64,${imgFirma}`
									: `data:image/png;base64,${IMAGEN_FIRMA_PREDEF}`,
								onclick: assignSignatureImage,
								typeImg: 'png',
								colorFirmante: 'transparent',
								idPdfContainer: idPdfContainer,
								position: paginasAnteriores,
							};
						} else {
							for (var i = 0; i < totaElem.length; i++) {
								let resPo = totaElem[i].id.split('_');
								let docv = Number(resPo[1]);
								let pagv = Number(resPo[2]);
								let arrd = { d: docv, p: pagv, v: acumData };
								acumData += totaElem[i].height;
								listPost.push(arrd);
							}
							finaPosX = fir.eje_x + maxMarIzq;
							tamaPage = listPost.find(
								a => a.d == doc.orden - 1 && a.p == fir.pageNumber
							).v; //identifico el documento y la pagina
							paginasAnteriores =
								listPost.findIndex(
									a => a.d === doc.orden - 1 && a.p === fir.pageNumber
								) + 1;
							tamaMarg = paginasAnteriores * 2 - 1; //Tengo esta margen (manuscrita.pagina * 2px 1px de arriba, y 1 px de abajo)le quito 1px porque el primer doc no lleva 1 px de la margen de arriba
							restPage = tamaPage + tamaMarg;
							finaPosY = fir.eje_y + restPage < 0 ? 0 : fir.eje_y + restPage;
							nomCamp = 'cpf_' + doc.orden + '_' + posCamp;
							totNom.push(nomCamp);
							fProps = {
								source: 'campoVacio',
								pageWidth: fir.pageWidth,
								isFieldempty: true,
								isReSign: true,
								idReSign: nomCamp,
								posY: finaPosY,
								posX: finaPosX,
								reSignWidth: fir.ancho,
								reSignHeigth: fir.alto,
								// imgRoute: AddSignature,
								imgRoute: imgFirma
									? `data:image/png;base64,${imgFirma}`
									: `data:image/png;base64,${IMAGEN_FIRMA_PREDEF}`,
								onclick: assignSignatureImage,
								typeImg: 'png',
								colorFirmante: 'transparent',
								idPdfContainer: idPdfContainer,
								position: paginasAnteriores,
							};
						}
						setSignFields(prevSignFields => [...prevSignFields, fProps]);

						CanvasDragResize(fProps);
						posCamp += 1;
					});
				});
				setMxSignOnScreen(posCamp - 1);
			}
			setTotaPositionSign(totNom);
		}
	}

	function findNextSignature(btForw) {
		let mxData = mnSignOnScreen;
		if (btForw) {
			mxData = mxData + 1 > mxSignOnScreen ? 1 : mxData + 1;
		} else {
			mxData = mxData - 1 <= 0 ? mxSignOnScreen : mxData - 1;
		}
		let totCamp = document.getElementsByClassName('container-sign');
		let finData = mxData - 1;
		setMnSignOnScreen(mxData);
		document.getElementById(totCamp[finData].id).scrollIntoView();
	}
	//Se elimina la data del el campo de firma en donde se va a reemplazar la imagen
	const eliminarDataFirma = id => {
		const PosicionesFirmantes = id;
		let array1 = sendData.documents;
		let array2 = data.documentos;
		const [_, x1, x2] = PosicionesFirmantes.split('_').map(x => parseInt(x));
		const listaManuscrita = [];
		for (let i = 0; i < array2.length; i++) {
			const documentoActual = array2[i];
			// Si el objeto actual tiene propiedades "manuscrita" y su longitud es mayor a cero, agregamos todas las manuscritas al array "listaManuscrita"
			if (documentoActual.manuscrita && documentoActual.manuscrita.length > 0) {
				listaManuscrita.push(...documentoActual.manuscrita);
			}
		}

		let objetoEncontrado = array2.find(objeto => objeto.orden === x1);

		// Si encontramos el objeto, buscamos el objeto correspondiente en array1
		if (objetoEncontrado) {
			let objetoArray1 = array1.find(
				objeto => objeto.nombre === objetoEncontrado.nombre
			);

			// Si encontramos el objeto correspondiente en array1, recorremos la propiedad typeSignature
			if (objetoArray1) {
				objetoArray1.typeSignature.forEach((typeSignature, index) => {
					// Comparamos los valores de typeSignature con los de listaManuscrita[x2]
					if (
						typeSignature.posXY.pageNumber ===
							listaManuscrita[x2 - 1].pageNumber &&
						typeSignature.posXY.x === listaManuscrita[x2 - 1].eje_x &&
						typeSignature.posXY.y === listaManuscrita[x2 - 1].eje_y &&
						typeSignature.posXY.width === listaManuscrita[x2 - 1].ancho &&
						typeSignature.posXY.height === listaManuscrita[x2 - 1].alto &&
						typeSignature.posXY.pageWidth ===
							listaManuscrita[x2 - 1].pageWidth &&
						typeSignature.posXY.pageHeight ===
							listaManuscrita[x2 - 1].pageHeight
					) {
						// Si encontramos una coincidencia, eliminamos la propiedad typeSignature de ese objeto
						if (objetoArray1.typeSignature.length === 1) {
							objetoArray1.typeSignature = [];
						} else {
							objetoArray1.typeSignature.splice(index, 1);
						}
					}
				});
			}
		}
		return setSendData({ ...sendData, documents: array1 });
	};

	return (
		<>
			<Grid container spacing={0} direction='row' id='modal-pdf'>
				<Container component='main' maxWidth='lg'>
					<h1 className={'title-background'}>
						{isDataLoaded
							? data?.firmante?.esObservador !== 0
								? 'Observador del documento'
								: 'Firmar documentos'
							: ' '}
					</h1>
				</Container>

				<Container component='main' maxWidth='lg'>
					<Grid
						container
						spacing={0}
						direction='row'
						justifyContent='flex-start'
						alignItems='flex-start'
						className='zone-upload-container'
						maxWidth='md'
					>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Paper elevation={0} className={'addSigner'}>
								<div className={classes.flex}>
									<div>
										<h2
											style={{
												color: '#E55200',
												fontSize: '24px',
												margin: '3px 0 0 0 ',
											}}
										>
											{isDataLoaded
												? data?.firmante?.esObservador !== 0
													? 'Observador del archivo'
													: 'Firma el archivo'
												: ' '}
										</h2>
										<p className={classes.size}>
											<b>
												{isDataLoaded
													? data?.firmante?.esObservador !== 0
														? 'Revisa y observa los documentos'
														: 'Revisa y firma tus documentos.'
													: ' '}
											</b>
										</p>
									</div>

									<div className={classes.btns}>
										{data?.firmante?.esObservador === 0 ? (
											<>
												<button
													className={classes.btnRechazar}
													onClick={() => dispatch(modalReject(true))}
												>
													Rechazar
												</button>
												<button
													className={classes.continue}
													onClick={() => handleClickItem()}
												>
													Firmar
												</button>
											</>
										) : (
											<button
												className={classes.continue}
												onClick={() => history.push('/home')}
											>
												Salir
											</button>
										)}
									</div>
								</div>
								<Grid container>
									<Grid
										item
										xs={12}
										sm={3}
										style={{
											paddingRight: window.innerWidth < 600 ? '0px' : '38px',
										}}
									>
										{firmaLibre && (
											<div className={classes.flx}>
												<p className={classes.parr}>
													{data?.firmante?.esObservador !== 0
														? ' '
														: '	Si lo deseas, puedes arrastrar esta opción para incluir tu firma en el documento.'}
												</p>
												{data?.firmante?.esObservador !== 0 ? null : (
													<Button
														onClick={() => dispatch(modalSign(true))}
														className={classes.btnCampoFirma}
													>
														<div className={classes.divTurqoise}>
															<img
																className={classes.backgroundTurquoise}
																src={IconManuscrita}
															/>
														</div>
														Campo de firma <AddIcon fontSize='small' />
													</Button>
												)}
											</div>
										)}
										{!firmaLibre && firmaManuscrita && (
											<div className={classes.parrafo}>
												Faltan {numeroFaltante} firmas{' '}
												<span className={classes.div}>
													<img
														src={atras}
														style={{ cursor: 'pointer' }}
														onClick={() => findNextSignature(false)}
													/>
													{mnSignOnScreen}/{mxSignOnScreen}
													<img
														src={siguiente}
														style={{ cursor: 'pointer' }}
														onClick={() => findNextSignature(true)}
													/>
												</span>
											</div>
										)}

										{firmaManuscrita && <hr className={classes.hr} />}

										<p className={classes.listado}>Listado firmantes</p>
										{firmantes
											?.filter(firmante => firmante.esObservador === 0)
											.map((firmante, index) =>
												firmante.estado == 1 &&
												data.firmante.correo === firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<div className={classes.circle2}>
																{' '}
																{index + 1}{' '}
															</div>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#000000' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esAprobador === 1 && (
																	<Tooltip title='Sin aprobar' arrow>
																		<CheckCircleIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esAprobador === 2 && (
																	<Tooltip title='Aprobado' arrow>
																		<CheckCircleIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '8px',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 1 &&
												  data.firmante.correo !== firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<div
																className={classes.circleDisabled}
																style={{
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{index + 1}{' '}
															</div>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esAprobador === 1 && (
																	<Tooltip title='Sin aprobar' arrow>
																		<CheckCircleIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esAprobador === 2 && (
																	<Tooltip title='Aprobado' arrow>
																		<CheckCircleIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 2 ? (
													<>
														<div className={classes.flexs2}>
															<div className={classes.circle}> ✔ </div>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esAprobador === 1 && (
																	<Tooltip title='Sin aprobar' arrow>
																		<CheckCircleIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esAprobador === 2 && (
																	<Tooltip title='Aprobado' arrow>
																		<CheckCircleIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 6 &&
												  data.firmante.correo === firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<div className={classes.circle2}>
																{' '}
																{index + 1}{' '}
															</div>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esAprobador === 1 && (
																	<Tooltip title='Sin aprobar' arrow>
																		<CheckCircleIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esAprobador === 2 && (
																	<Tooltip title='Aprobado' arrow>
																		<CheckCircleIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 6 &&
												  data.firmante.correo !== firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<div className={classes.circleDisabled}>
																{index + 1}{' '}
															</div>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esAprobador === 1 && (
																	<Tooltip title='Sin aprobar' arrow>
																		<CheckCircleIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esAprobador === 2 && (
																	<Tooltip title='Aprobado' arrow>
																		<CheckCircleIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '8px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : null
											)}
										{firmantes?.some(
											firmante => firmante.esObservador !== 0
										) && (
											<p className={classes.listado2}>Listado de observador</p>
										)}
										{firmantes
											?.filter(firmante => firmante.esObservador !== 0)
											.map((firmante, index) =>
												firmante.estado == 1 &&
												data.firmante.correo === firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#000000' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esObservador === 1 && (
																	<Tooltip title='Observador' arrow>
																		<VisibilityIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esObservador === 2 && (
																	<Tooltip title='Observado' arrow>
																		<VisibilityIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 1 &&
												  data.firmante.correo !== firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esObservador === 1 && (
																	<Tooltip title='Observador' arrow>
																		<VisibilityIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esObservador === 2 && (
																	<Tooltip title='Observado' arrow>
																		<VisibilityIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 2 ? (
													<>
														<div className={classes.flexs2}>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esObservador === 1 && (
																	<Tooltip title='Observador' arrow>
																		<VisibilityIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esObservador === 2 && (
																	<Tooltip title='Observado' arrow>
																		<VisibilityIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 6 &&
												  data.firmante.correo === firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esObservador === 1 && (
																	<Tooltip title='Observador' arrow>
																		<VisibilityIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esObservador === 2 && (
																	<Tooltip title='Observado' arrow>
																		<VisibilityIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : firmante.estado == 6 &&
												  data.firmante.correo !== firmante.email ? (
													<>
														<div className={classes.flexs2}>
															<span
																title={firmante.nombre}
																style={{
																	marginLeft: '10px',
																	fontSize: '14px',
																	color: lineal ? '#c8c8c8' : '#000000',
																}}
															>
																{truncarNombreCompleto(firmante.nombre, '', 25)}
																{firmante.esObservador === 1 && (
																	<Tooltip title='Observador' arrow>
																		<VisibilityIcon
																			style={{
																				color: 'black',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
																{firmante.esObservador === 2 && (
																	<Tooltip title='Observado' arrow>
																		<VisibilityIcon
																			style={{
																				color: '#e55302',
																				fontSize: '1rem',
																				marginLeft: '18px',
																			}}
																		/>
																	</Tooltip>
																)}
															</span>
														</div>
													</>
												) : null
											)}
										{!firmaLibre && firmaManuscrita && (
											<div className={classes.parrafo2}>
												Faltan {numeroFaltante} firmas{' '}
												<span className={classes.div}>
													<img
														src={atras}
														style={{
															cursor: 'pointer',
															transform: 'scale(1.3)',
														}}
														onClick={() => findNextSignature(false)}
													/>
													{mnSignOnScreen}/{mxSignOnScreen}
													<img
														src={siguiente}
														style={{
															cursor: 'pointer',
															transform: 'scale(1.3)',
														}}
														onClick={() => findNextSignature(true)}
													/>
												</span>
											</div>
										)}
									</Grid>
									<Grid item xs={12} sm={9} md={6} lg={6}>
										<BotoneraEditar
											scale={scale}
											setScale={setScale}
											firmas={firmas}
											reSignImage={reSignImage}
											sendData={sendData}
											deleteSign={deleteSign}
											setReSign={setReSign}
											imageSignature={imageSignature}
										/>
										<Box className={classes.boxes}>
											<Grid container style={{ width: '100%', height: '100%' }}>
												{
													<div
														id={idPdfContainer}
														className='drag-container'
														style={{ width: 'auto', height: 'auto', maxWidth: '100%', maxHeight:'100%'}}
													>
														{imgSign &&
															imageSignature.map(signature => (
																<CanvasDragResize
																	colorFirmante={signature.colorFirmante}
																	idPdfContainer={idPdfContainer}
																	currentDoc={currentDoc}
																	setCurrentDoc={setCurrentDoc}
																	imgRoute={signature.imgRoute}
																	endRender={async () => {
																		setImgSign(null);
																		setReSign(false);
																	}}
																	onMouseUp={onMouseUp}
																	typeImg={signature.typeImg}
																	deleteSign={signature.deleteSign}
																	isReSign={isReSign}
																	posX={signature.posX}
																	posY={signature.posY}
																	reSignWidth={signature.reSignWidth}
																	reSignHeigth={signature.reSignHeigth}
																	idReSign={signature.idReSign}
																	predefinedSource={predefinedSource}
																	setPredefinedSource={setPredefinedSource}
																	onclick={!firmaLibre && assignSignatureImage}
																/>
															))}
													</div>
												}
											</Grid>
										</Box>
									</Grid>
									<Grid
										item
										sm={3}
										className={classes.none}
										style={{ paddingLeft: '28px' }}
									>
										<Grid item className={classes.miniContainer}>
											<Grid item className={'fullContainer'}>
												<Grid className='pdf-miniaturas pdf-miniaturasCF'>
													<div style={{ display: 'none' }}>
														<input
															accept='application/pdf'
															multiple=''
															type='file'
															id='Upload'
															onChangeCapture={handlerChange}
														/>
													</div>
													<Grid
														id={idThumbnailsContainer}
														className='pdf-miniaturas-firmas pdf-miniaturas-firmasCF'
														onClick={refreshDoc}
													></Grid>
													<Grid item xs={0}>
														<div
															style={{
																display: 'none',
																padding: '8px',
																float: 'right',
															}}
															id='dvCurrentPageNumber'
														>
															Página: {currentPage}
														</div>
													</Grid>
												</Grid>
											</Grid>
										</Grid>
									</Grid>

									<div className={classes.btns2} style={{ marginTop: '20px' }}>
										{data?.firmante?.esObservador === 0 ? (
											<>
												<button
													className={classes.btnRechazar}
													onClick={() => dispatch(modalReject(true))}
												>
													Rechazar
												</button>
												<button
													className={classes.continue}
													onClick={() => handleClickItem()}
												>
													Firmar
												</button>
											</>
										) : (
											<button
												className={classes.continue}
												onClick={() => history.push('/home')}
											>
												Salir
											</button>
										)}
									</div>
								</Grid>
							</Paper>
						</Grid>
					</Grid>
				</Container>
				{modalRejects && <ModalReject correoCreador={correoCreador} />}
				{modalConfirmRejects && (
					<ModalConfirmReject
						idCircuito={data.circuito.id}
						idFirmante={data.firmante.id}
						TokenClient={token}
						setErrorS3={setErrorsS3}
						setRedireccionar={setRedireccionar}
					/>
				)}
				{modalUpss && (
					<ModalUps
						normal={false}
						mensaje={errorsS3}
						redireccionar={redireccionar}
						userDigitalWare={userDigitalWare}
					/>
				)}
				{modalSignatureRejects && <ModalSignatureRejected irhome={true} />}
				{modalMissingSignature && (
					<ModalMissingSignatures faltantes={numeroFaltante} />
				)}

				{modalSigns && (
					<div className={classes.modal}>
						<ModalSign
							setReSign={setReSign}
							eliminarDataFirma={eliminarDataFirma}
							targetId={targetId}
							setTargetId={setTargetId}
							setSignImage={setSignImage}
							setDigitalSign={setDigitalSign}
							setSignPredefined={setSignPredefined}
							setAddDataCert={setAddDataCert}
							aplicarFirma={aplicarFirma}
							digital={digital}
							setTypeImg={setTypeImg}
							manuscrita={manuscrita}
							signPredefined={signPredefined}
							showComplete={showComplete}
							setDigitalImg={setDigitalImg}
							tieneFirmaDigital={tieneFirmaDigital}
							sendData={sendData}
							setStateFirmas={cerrarModal}
							cliente={true}
							campoFirma={campoFirma}
							firmarConCampos={firmarConCampos}
							setTodosLosCampos={setTodosLosCampos}
							devuelveImagen={true}
							firmanteCorreo={false}
							firmasHechas={firmasHechas}
							firmasNecesarias={firmasNecesarias}
							setFirmasHechas={setFirmasHechas}
							userFirmaya={true}
						/>
					</div>
				)}
			</Grid>
			{/* {
                statusModalSign &&
                // <ModalOtp setStatusModalSign={setStatusModalSign} outMail={data.firmante.correo} sendElecSign={sendElecSign} setSendElecSign={setSendElecSign}/>
                <ModalOtpCF setStatusModalSign={setStatusModalSign} email={data.firmante.correo} sendElecSign={sendElecSign} setSendElecSign={setSendElecSign} setLoading={setLoading} firmante={data.firmante.id} circuito={data.circuito.id} />
            } */}
			{firmado && <ModalFinishedSigning irHome={true} />}
			{loading && <Loading />}
			{loadingRedux && <Loading />}
			{statusModal && (
				<ModalFirmaCliente
					services={services}
					setServices={setServices}
					vencimiento={vencimiento}
					isOpen={statusModal}
					onClose={onClose}
					info={infoModal}
					filesSize={sizeFiles}
					isP7={isP7}
					style={style}
					rows={rows}
					selected={selected}
					setStatusModal={setStatusModal}
					irHome={true}
					firmante={data.firmante.id}
					circuito={data.circuito.id}
					ultimaPosicion={ultimaPosicion}
					dataSignatory={data.documentos}
					terminaFirma={terminaFirma}
					sendData={sendData}
					signApply={signApply}
					setErrorsS3={setErrorsS3}
					statusModaltoken={statusModaltoken}
					setStatusModaltoken={setStatusModaltoken}
					setRedireccionar={setRedireccionar}
					lineal={lineal}
				/>
			)}
			{modalPantallaCarga && (
				<MessagePantallaCarga
					message={message}
					checks={checks}
					personaEliminada={personaEliminada}
					irHome={true}
				/>
			)}
		</>
	);
};

export default SignerCF;
